// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"mobile_action-module__wrapper--1aLYa"};